export default __webpack_public_path__ + "static/media/jsjq.e4a6603a.png";